import { config as base } from '@tamagui/config'
import { createFont, createTamagui } from 'tamagui'

const inter = createFont({
  family: 'Inter',
  size: {
    1: 11,
    2: 12,
    3: 14,
    4: 16,
    5: 18,
    6: 20,
    7: 24,
    8: 28,
    9: 32,
    10: 36,
    22: 22
  },
  // Line heights tuned tighter (Apple HIG-ish ratios): ~1.15-1.2 for
  // large titles, ~1.3-1.4 for body. Sizes stay the same; only leading
  // is reduced so text (especially on mobile) reads less spaced out.
  lineHeight: {
    1: 14,
    2: 16,
    3: 18,
    4: 22,
    5: 24,
    6: 26,
    7: 30,
    8: 34,
    9: 38,
    10: 42,
    22: 28,
  },
  // weight: {
  //   400: '400',
  //   500: '500',
  //   600: '600',
  //   700: '700',
  // },
  face: {
    400: { normal: 'InterRegular',  italic: 'InterItalic' },
    500: { normal: 'InterMedium',   italic: 'InterMediumItalic' },
    600: { normal: 'InterSemiBold', italic: 'InterSemiBoldItalic' },
    700: { normal: 'InterBold',     italic: 'InterBoldItalic' },
  },
})

export const config = createTamagui({
  ...base,
  defaultTheme: 'dark',

  tokens: {
    ...base.tokens,
    color: {
      ...base.tokens.color,

      // semantic/utility
      darkBase: '#0D0D0D',

      // neutrals (light→dark)
      neutral0:   '#FFFFFF',
      neutral50:  '#FAFAFA',
      neutral100: '#F5F5F5',
      neutral200: '#E5E7EB',
      neutral300: '#D1D5DB',
      neutral400: '#9CA3AF',
      neutral500: '#6B7280',
      neutral600: '#4B5563',
      neutral700: '#374151',
      neutral800: '#1F2937',
      neutral900: '#111827',
      neutral1000:'#000000',

      // brand & states
      brand:   '#F2663A',
      success: '#00B176',
      warning: '#F5B700',
      error:   '#E52600',

      // gradient colors for play button
      gradientStart: '#FFB671',
      gradientEnd: '#FF2273',
    },
  },

  fonts: {
    heading: inter,
    body: inter,
    mono: base.fonts.mono,
  },

  themes: {
    light: {
      header:  '#0D0D0D',  // header background (light mode)
      bg:      '#F4F1ED',  // page background
      textColor: '#0D0D0D',
      white:   '#FFFFFF',
      darkBase:'#0D0D0D',

      fg:      '#111111',
      bgPanel: '#F7F7F7',
      muted:   '#6B7280',
      accent:  '#F2663A',
      border:  '#E5E7EB',
      card:    '#FFFFFF',
    },
    dark: {
      header:  '#000000',  // header background (dark mode)
      bg:      '#0B0B0B',  // page background
      textColor: '#FFFFFF',
      white:   '#FFFFFF',
      darkBase:'#0D0D0D',

      fg:      '#FFFFFF',
      bgPanel: '#111111',
      muted:   '#A0A0A0',
      accent:  '#F2663A',
      border:  '#1F2937',
      card:    '#111111',
    },
  },

 
    // Example: <Text size="$4" $gtSm={{ size: '$6' }} />
  media: {
    xs:   { maxWidth: 479 },
    sm:   { maxWidth: 767 },
    md:   { maxWidth: 1023 },
    lg:   { maxWidth: 1279 },

    gtXs: { minWidth: 480 },
    gtSm: { minWidth: 768 }, //greater than small
    gtMd: { minWidth: 1024 }, //greater than medium
    gtLg: { minWidth: 1280 },

    short: { maxHeight: 539 },
    tall:  { minHeight: 540 },
  },
})

export type AppTamaguiConfig = typeof config

declare module 'tamagui' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface TamaguiCustomConfig extends AppTamaguiConfig {}
}

export default config
